import { createFileRoute, redirect } from "@tanstack/react-router";

/** A gateway-scoped link opens the project inbox filtered to that gateway. */
export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways/$gatewayId/suggestions"
)({
  beforeLoad({ params }) {
    throw redirect({
      params: {
        organizationId: params.organizationId,
        projectId: params.projectId,
      },
      replace: true,
      search: { gateway_id: [params.gatewayId] },
      to: "/orgs/$organizationId/projects/$projectId/suggestions",
    });
  },
});
